const eventUrls={
    fetchEvents:{
        url:'/testing/event/'
    },
    fetchEvent:{
        url:'/testing/event/:id'
    },
    downloadRegistrationList:{
        url:'/testing-event/:id/registrationList'
    },
    generateTokenList:{
        url:'/testing-event/:id/generateTokenList'
    },
    rejectEvent:{
        url:'/testing-event/:id/reject'
    },
    fetchFormOptions:{
        url:'/testing/actions/eventFormOptions'
    },
    getCandidates:{
        url:'/testing-event/:id/candidates'
    },
    logins:{
        url:'/testing-event/:id/logins'
    }
};
export default eventUrls;
